/*
 * @Descripttion: mxgraph 自定义toolbar
 * @Author: zenghua.wang
 * @Date: 2021-06-28 15:09:51
 * @LastEditors: zenghua.wang
 * @LastEditTime: 2021-08-11 11:53:21
 */
import { MxConstants } from '@/apisManage/mxgraph'

// 此处图片需放在publi下，否则mxgraph报错
const iconPre = './cdn/mxgraph/images'
const iconBegin = `${iconPre}/begin.png`
const iconTable = `${iconPre}/table.png`
const iconRest = `${iconPre}/rest.png`
const iconData = `${iconPre}/data.png`
const iconConst = `${iconPre}/const.png`
const iconOutput = `${iconPre}/output.png`

// begin, line, table, http, constant, data, respons
/**
 * shapes特别字段用途说明
 * title:      控件在画布上显示的名称
 * name:       存储控件的变量名称，在输出控件的时候供选择
 * value:      控件的类型，在点击控件显示不同类型(value)的弹窗
 * index:      编辑画布控件的时候，画布控件对应模型数据的索引
 * createTime: 多个控件回显时候，模型数据按时间排序，达到模型数据对应画布控件的index
 * 其中index、createTime 在 eidtor.js中默认自定义维护
 */
export const shapes = [
  {
    icon: iconBegin,
    title: '开始',
    name: null,
    data: null,
    value: 'begin',
    width: 50,
    height: 50,
    style: {
      fillColor: 'transparent', // 填充色
      strokeColor: 'transparent', // 线条颜色
      strokeWidth: '1', // 线条粗细
      fontColor: '#666',
      fontSize: '10',
      shape: MxConstants.SHAPE_LABEL, // 形状
      align: MxConstants.ALIGN_CENTER, // 水平方向对其方式
      verticalAlign: MxConstants.ALIGN_CENTER, // 垂直方向对其方式
      verticalLabelPosition: MxConstants.ALIGN_BOTTOM,
      imageAlign: MxConstants.ALIGN_CENTER, // 图形水平方向对其方式
      imageVerticalAlign: MxConstants.ALIGN_CENTER, // 图形方向对其方式
      imageWidth: 50,
      imageHeight: 50,
      image: iconBegin // 图形
    },
    hidden: true,
    defaultAdd: true
  },
  {
    icon: iconTable,
    title: 'table查询',
    name: null,
    data: null,
    value: 'table',
    width: 50,
    height: 50,
    style: {
      fillColor: 'transparent',
      strokeColor: 'transparent',
      strokeWidth: '1',
      fontColor: '#666',
      fontSize: '10',
      shape: MxConstants.SHAPE_LABEL,
      align: MxConstants.ALIGN_CENTER,
      verticalAlign: MxConstants.ALIGN_CENTER,
      verticalLabelPosition: MxConstants.ALIGN_BOTTOM,
      imageAlign: MxConstants.ALIGN_CENTER,
      imageVerticalAlign: MxConstants.ALIGN_CENTER,
      imageWidth: 50,
      imageHeight: 50,
      image: iconTable
    },
    hidden: false,
    disabled: false
  },
  {
    icon: iconRest,
    title: 'rest服务',
    name: null,
    data: null,
    value: 'http',
    width: 50,
    height: 50,
    style: {
      fillColor: 'transparent',
      strokeColor: 'transparent',
      strokeWidth: '1',
      fontColor: '#666',
      fontSize: '10',
      shape: MxConstants.SHAPE_LABEL,
      align: MxConstants.ALIGN_CENTER,
      verticalAlign: MxConstants.ALIGN_CENTER,
      verticalLabelPosition: MxConstants.ALIGN_BOTTOM,
      imageAlign: MxConstants.ALIGN_CENTER,
      imageVerticalAlign: MxConstants.ALIGN_CENTER,
      imageWidth: 50,
      imageHeight: 50,
      image: iconRest
    },
    hidden: false,
    disabled: false
  },
  {
    icon: iconData,
    title: '数据加工',
    name: null,
    data: null,
    value: 'data',
    width: 50,
    height: 50,
    style: {
      fillColor: 'transparent',
      strokeColor: 'transparent',
      strokeWidth: '1',
      fontColor: '#666',
      fontSize: '10',
      shape: MxConstants.SHAPE_LABEL,
      align: MxConstants.ALIGN_CENTER,
      verticalAlign: MxConstants.ALIGN_CENTER,
      verticalLabelPosition: MxConstants.ALIGN_BOTTOM,
      imageAlign: MxConstants.ALIGN_CENTER,
      imageVerticalAlign: MxConstants.ALIGN_CENTER,
      imageWidth: 50,
      imageHeight: 50,
      image: iconData
    },
    hidden: false,
    disabled: false
  },
  {
    icon: iconConst,
    title: '常量转换',
    name: null,
    data: null,
    value: 'constant',
    width: 50,
    height: 50,
    style: {
      fillColor: 'transparent',
      strokeColor: 'transparent',
      strokeWidth: '1',
      fontColor: '#666',
      fontSize: '10',
      shape: MxConstants.SHAPE_LABEL,
      align: MxConstants.ALIGN_CENTER,
      verticalAlign: MxConstants.ALIGN_CENTER,
      verticalLabelPosition: MxConstants.ALIGN_BOTTOM,
      imageAlign: MxConstants.ALIGN_CENTER,
      imageVerticalAlign: MxConstants.ALIGN_CENTER,
      imageWidth: 50,
      imageHeight: 50,
      image: iconConst
    },
    hidden: false,
    disabled: false
  },
  {
    icon: iconOutput,
    title: '输出配置',
    name: null,
    data: null,
    value: 'respons',
    width: 50,
    height: 50,
    style: {
      fillColor: 'transparent',
      strokeColor: 'transparent',
      strokeWidth: '1',
      fontColor: '#666',
      fontSize: '10',
      shape: MxConstants.SHAPE_LABEL,
      align: MxConstants.ALIGN_CENTER,
      verticalAlign: MxConstants.ALIGN_CENTER,
      verticalLabelPosition: MxConstants.ALIGN_BOTTOM,
      imageAlign: MxConstants.ALIGN_CENTER,
      imageVerticalAlign: MxConstants.ALIGN_CENTER,
      imageWidth: 50,
      imageHeight: 50,
      image: iconOutput
    },
    hidden: false,
    disabled: false
  }
]
